import { Badge } from "@/components/ui/badge"
import type { TCategory } from "@/http/finance"
import { cn } from "@/lib/utils"

type TCategoryBadgeProps = {
  category: TCategory
  className?: string
}

export function CategoryBadge({ category, className }: TCategoryBadgeProps) {
  const isIncome = category.type === "INCOME"
  const colorClasses = isIncome
    ? "bg-emerald-100 text-emerald-900 border-emerald-200"
    : "bg-rose-100 text-rose-900 border-rose-200"

  return (
    <Badge variant="outline" className={cn(colorClasses, className)}>
      {category.name} ({isIncome ? "Receita" : "Despesa"})
    </Badge>
  )
}
